import React from "react";
import cx from "classnames";
import { useProgressDisplayed } from "pages/Event/hooks/utils/useDisplayedProgress";
import { useProgressHelpers } from "pages/Event/hooks/utils/useProgressHelpers";

type Props = React.ComponentProps<"div"> & {
  progress: number;
};

const EventProgress = (props: Props) => {
  const { progress: progressDisplayed } = useProgressDisplayed(props.progress);

  const { isInProgress } = useProgressHelpers(progressDisplayed);

  return (
    <div className={cx(["bg-white bg-opacity-10 w-full h-4 relative rounded-full", props.className])}>
      <div
        className={cx([
          "bg-gradient-to-bl from-[#ece9f9] to-[#cfbdff] absolute inset-0 rounded-full",
          {
            "min-w-[5%] max-w-[95%]": isInProgress,
          },
        ])}
        style={{ width: `${progressDisplayed * 100}%` }}
      />
    </div>
  );
};

export default EventProgress;
